import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { statesItems } from '../wikiutil';
import { InputBaseContainer, InputSelectWithLabel } from '../../../molecules';

const StatesDropdown = ({ control, setValue, watch, errors }) => {
  const defaultState = { id: 'FL', name: 'Florida' };
  const [stateValue, setStateValue] = useState<any>(defaultState);

  const val = watch('state');
  useEffect(() => {
    setValue('state', defaultState);
  }, []);

  useEffect(() => {
    if (val) {
        setValue('state', val);
        setStateValue(val);
    }
  }, [val]);

  return (
    <InputBaseContainer>
      <Controller
        name="state"
        defaultValue={stateValue}
        control={control}
        render={props => (
          <InputSelectWithLabel
            selectAllActive
            placeholder=""
            menuPlacement="auto"
            isLoading={false}
            label="State"
            error={errors?.state}
            isDisabled={false}
            getOptionValue={(item: any) => item.id || Math.random()}
            getOptionLabel={(item: any) => item.name}
            isRequired
            options={statesItems}
            {...props}
          />
        )}
      />
    </InputBaseContainer>
  );
};

export default StatesDropdown;

const Select = styled.select`
  width: 100%;
  height: 40px;
  margin-top: 8px;
  border-color: var(--defaultTableCellTitle);
  background-color: white;
`;
